import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import FaqComponent from './FaqComponent';

/**
 * @typedef {import("@prismicio/client").Content.FaqSlice} FaqSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FaqSlice>} FaqProps
 * @param { FaqProps }
 */
const Faq = ({ slice }) => (
  <section>
    <FaqComponent slice={slice} />
  </section>
)

export default Faq